<div class="grid-fluid">
  <div class="footer-block" *ngFor="let node of nodes">
    <div class="footer-block-heading">{{ node.title }}</div>
    <ul>
      <li *ngFor="let item of node.children">
        <a class="link" [href]="item.url" [title]="item.tooltip || item.title">{{ item.title }}</a>
      </li>
    </ul>
  </div>
</div>

<p>
  Super-powered by Google ©2010-2022.
</p>
<p>
  Code licensed under an <a href="license" title="License text">MIT-style License</a>.
  Documentation licensed under <a href="https://creativecommons.org/licenses/by/4.0/">CC BY 4.0</a>.
</p>
<p>
  Version {{versionInfo?.full}}.
</p>
